export interface RawVariantDocument {
    hawk_child_attributes?: Array<Record<string, Array<string>>>;
    hawk_child_attributes_hits?: Array<{
        Items: Array<Record<string, Array<string>>>;
        NofPages: number;
        NofResults: number;
    }>;
}
